import { Component, Input } from '@angular/core';

@Component({
  selector: 'dp-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent {
  @Input('text') public text = '';
  @Input('variant') public variant = 'default';
  @Input('icon') public icon = '';
}
